var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center",staticStyle:{"height":"100%"}},[_c('vx-tooltip',{attrs:{"text":"Modifier l'URL LinkedIn","placement":"top"}},[_c('span',{staticClass:"cursor-pointer",on:{"click":_vm.handleClick}},[_c('feather-icon',{staticClass:"m-0",staticStyle:{"color":"#0a66c2"},attrs:{"icon":"EditIcon"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }